import AdminEdit from './AdminEdit';

export default AdminEdit;